import { render, staticRenderFns } from "./UpdatePartPrices.vue?vue&type=template&id=395ab833"
import script from "./UpdatePartPrices.vue?vue&type=script&lang=js"
export * from "./UpdatePartPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports